// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1oCfK","selected":"Chip_selected__1g6T3"};